<div class="slider-container" #container>
  <div class="slider-mask">
    <div class="slider-bg" [style.top]="handlePosition"></div>
    <div class="slider-line" [style.top]="handlePosition"></div>
  </div>
  <div class="slider-handle-container" [style.top]="handlePosition">
    <div class="slider-handle" #handle></div>
  </div>
</div>
